module.exports = __webpack_public_path__ + "static/media/logsicon.1ac183d0.svg";